import {createTheme, ThemeOptions} from '@mui/material'

import {componentsOverrides} from './componentsOverrides'
import {
  darkModeShadows,
  hpDarkPalette,
  hpLightPalette,
  lightModeShadows,
  typographyTokens,
  shapeTokens
} from './designTokens'

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    formLabel: true
    captionBold: true
  }
}

declare module '@mui/material/styles' {
  interface TypeText {
    primarySoft: string
    secondarySoft: string
  }
  interface TypeTextOptions {
    primarySoft?: string
    secondarySoft?: string
  }
}

// Light theme
const hpLightThemeOptions: ThemeOptions = {
  palette: hpLightPalette,
  shadows: lightModeShadows,
  shape: shapeTokens,
  typography: typographyTokens,
  components: componentsOverrides
}

export const hpTheme = createTheme(hpLightThemeOptions)

// Dark theme
const darkThemeOptions: ThemeOptions = {
  palette: hpDarkPalette,
  shadows: darkModeShadows,
  shape: shapeTokens,
  typography: typographyTokens,
  components: componentsOverrides
}
export const hpDarkTheme = createTheme(darkThemeOptions)
